// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NmnhAT_BQBnZIXtEHm5A{border-top:1px solid var(--border-neutral-default);padding:8px}`, "",{"version":3,"sources":["webpack://./src/pages/campaigns/ui/CampaignSchedule/ui/DelayContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,kDAAA,CACA,WAAA","sourcesContent":[".wrap {\n  border-top: 1px solid var(--border-neutral-default);\n  padding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `NmnhAT_BQBnZIXtEHm5A`
};
export default ___CSS_LOADER_EXPORT___;
